module.exports = __webpack_public_path__ + "img/img-wallet-sec-10-m.png";